<template>
  <div>
    <b-button
      id="btn-excel"
      ref="btnexcel"
      variant="primary"
      size="sm"
      style="
        margin-right: 1%;
        background: #37ef00 !important;
        border-color: #37ef00 !important;
      "
      @click="getMarcacion((excel_btn = '1'))"
    >
      <font-awesome-icon icon="fa-solid fa-file-excel" />
    </b-button>
    <b-button
      id="btn-pdf"
      variant="danger"
      size="sm"
      @click="getMarcacion(excel_btn = '', pdf_btn = '1')"
    >
      <font-awesome-icon icon="fa-solid fa-file-pdf" />
    </b-button>
    <b-modal
      id="modal-lg"
      ref="modal-persona"
      ok-only
      ok-title="Aceptar"
      centered
      size="lg"
      title="Detalle persona"
      style="font-weight: bold"
    >
      <b-row v-if="this.field_persona">
        <b-col cols="4">
          <b-form-group
            label="Identificación:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_persona.cedula"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="RUC:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_persona.ruc ? this.field_persona.ruc : 'N/A'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Tipo:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="
                this.field_persona.tipoNatJur === 'N' ? 'Natural' : 'Jurídica'
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Tipo pasajero:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.procesarTipoPasajero(field_persona.tipoPasajero)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Nombre comercial:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="
                this.field_persona.nombreComercial
                  ? this.field_persona.nombreComercial
                  : 'N/A'
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Razón social:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="
                this.field_persona.razonSocial
                  ? this.field_persona.razonSocial
                  : 'N/A'
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Correo electrónico:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="
                this.field_persona.email ? this.field_persona.email : 'N/A'
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Extranjero:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_persona.esExtranjero ? 'Sí' : 'No'"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="modal-lg"
      ref="modal-boleto"
      ok-only
      ok-title="Aceptar"
      centered
      size="lg"
      title="Detalle boleto"
      style="font-weight: bold"
    >
      <b-row v-if="this.field_boleto">
        <b-col cols="12">
          <b-form-group
            label="Código QR:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_boleto.codigoQr"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Número documento:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_boleto.numero_documento"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Secuencia:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_boleto.secuencia"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Tipo de boleto:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.procesarTipoBoleto(this.field_boleto.tipoBoleto)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Tipo de tarifa:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.procesarTipoTarifa(this.field_boleto.tipoTarifa)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Producto contífico:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_boleto.producto_contifico"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-card-code class="principal mt-2">
      <b-row class="principal mt-2">
        <b-col md="4">
          <b-form-group>
            <label>Código de viaje:</label>
            <b-form-input
              v-model="codigo"
              placeholder="Buscar por código"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Tipos de marcaciones:</label>
            <v-select
              id="tipos_marcaciones"
              v-model="tipo_marcacion"
              :options="tipos_marcaciones"
              :reduce="(option) => option.value"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Observaciones:</label>
            <b-form-input
              v-model="observaciones_filtro"
              placeholder="Buscar por observaciones"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" v-if="this.tipo_marcacion === 'VAL'">
          <b-form-group>
            <label for="fecha-hasta">Fecha de validación (desde): </label>
            <flat-pickr
              v-model="fecha_desde"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4" v-if="this.tipo_marcacion === 'VAL'">
          <b-form-group>
            <label for="fecha-hasta">Fecha de validación (hasta): </label>
            <flat-pickr
              v-model="fecha_hasta"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha hasta..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-hasta">Fecha de marcación (desde): </label>
            <flat-pickr
              v-model="fecha_desde_marcacion"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde marcación..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-hasta">Fecha de marcación (hasta): </label>
            <flat-pickr
              v-model="fecha_hasta_marcacion"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha hasta marcación..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="pb-2">
          <b-button variant="primary" size="sm" @click="filtrar">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>
    <b-overlay
      :show="mostrarLoader"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
    >
      <b-card-code class="principal">
        <b-row class="mt-2">
          <b-col v-if="items.length > 0" cols="12">
            <!-- <b-card-title class="font-medium-2" style="text-align: center">
              <span>Tabla de marcaciones</span>
            </b-card-title> -->
            <b-table
              bordered
              striped
              responsive
              :items="items"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              class="mb-1"
              small
            >
              <template #cell(persona)="data">
                <div>
                  <a v-if="data.item.persona">
                    <span v-b-tooltip.hover title="Persona">
                      <feather-icon icon="UserIcon" size="14" />
                    </span>
                    <b-link @click="abrirDetalleMarcacion(data.item)">
                      <a> {{ data.item.persona.razonSocial }} </a>
                    </b-link>
                  </a>
                  <a v-else-if="data.item.boleto">
                    <span v-b-tooltip.hover title="Boleto">
                      <svg-icon type="mdi" :path="path" size="14" />
                    </span>
                    <b-link @click="abrirDetalleMarcacion(data.item)">
                      <a>
                        {{ data.item.boleto.numero_documento }}
                        <span v-b-tooltip.hover title="Secuencia">
                          <b-badge variant="light-secondary">
                            {{ data.item.boleto.secuencia }}
                          </b-badge>
                        </span>
                      </a>
                    </b-link>
                  </a>
                  <a v-else> - </a>
                  <span
                    v-if="
                      data.item.validacionCaducidad &&
                      data.item.marcacion_correcta === false
                    "
                    v-b-tooltip.hover
                    :title="
                      data.item.validacionCaducidad.usuario.username +
                      ' ' +
                      new Date(
                        data.item.validacionCaducidad.fecha_hora_validacion
                      ).toLocaleString('pt-BR')
                    "
                    class="text-danger ml-1"
                  >
                    <feather-icon icon="XCircleIcon" size="16" />
                  </span>
                  <span
                    v-if="
                      data.item.validacionCaducidad &&
                      data.item.marcacion_correcta === true
                    "
                    v-b-tooltip.hover
                    :title="
                      data.item.validacionCaducidad.usuario.username +
                      ' ' +
                      new Date(
                        data.item.validacionCaducidad.fecha_hora_validacion
                      ).toLocaleString('pt-BR')
                    "
                    class="text-success ml-1"
                  >
                    <feather-icon icon="CheckCircleIcon" size="16" />
                  </span>
                  <b-button
                    v-if="
                      permisos.indexOf('gest_bol_cadu_marcacion') !== -1 &&
                      data.item.caducado_pendiente_revisar
                    "
                    variant="warning"
                    size="sm"
                    class="ml-1"
                    @click="validarBoleto(data.item.token)"
                  >
                    <feather-icon icon="AlertOctagonIcon" class="mr-50" />
                    <span class="align-middle">Validar</span>
                  </b-button>
                </div>
                <div class="demo-inline-spacing">
                  <b-badge
                    variant="primary"
                    class="badge-glow"
                    style="margin-top: 5px"
                    v-b-tooltip.hover title="Código de viaje"
                  >
                    {{ data.item.viaje.codigo || 'N/A' }}
                  </b-badge>
                  {{ data.item.viaje.chofer.first_name }} {{ data.item.viaje.chofer.last_name }}
                </div>
              </template>
              <template #cell(fechaMarcacion)="data">
                <span
                  v-b-tooltip.hover
                  title="Fecha de marcación"
                  class="text-success"
                  ><feather-icon icon="ClockIcon" size="14" />
                </span>
                <a style="font-size: 12px">{{
                  new Date(data.value).toLocaleString("pt-BR")
                }}</a>
                <br />
                <span
                  v-b-tooltip.hover
                  title="Fecha de creación o subida"
                  class="text-warning"
                  ><feather-icon icon="ClockIcon" size="14" />
                </span>
                <a style="font-size: 12px">{{
                  new Date(data.item.fechaCreacion).toLocaleString("pt-BR")
                }}</a>
              </template>
              <template #cell(tipoPasajero)="data">
                <div v-if="data.item.persona">
                  {{ procesarTipoPasajero(data.item.persona.tipoPasajero) }}
                </div>
                <div v-else>N/A</div>
              </template>
              <template #cell(tipoBoleto)="data">
                <div v-if="data.item.boleto">
                  {{ procesarTipoBoleto(data.item.boleto.tipoBoleto) }}
                </div>
                <div v-else>N/A</div>
              </template>
              <template #cell(tipoTarifa)="data">
                <div v-if="data.item.boleto">
                  {{ procesarTipoTarifa(data.item.boleto.tipoTarifa) }}
                </div>
                <div v-else>N/A</div>
              </template>
            </b-table>
          </b-col>

          <p v-else class="mt-1">No hay registros para mostrar</p>
          <b-col cols="12" class="mb-2">
            <b-pagination
              v-if="items.length > 0"
              v-model="currentPageModificado"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              :small="true"
              class="mb-0"
              align="center"
              prev-class="prev-item"
              next-class="next-item"
              @change="prueba"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </b-card-code>
    </b-overlay>
  </div>
</template>
<script>
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiTicket } from "@mdi/js";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BOverlay,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BPagination,
  BTable,
  BLink,
  BCardHeader,
  BCardTitle,
  BTooltip,
  VBTooltip,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code";
import { required, integer } from "@validations";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import es from "vee-validate/dist/locale/es.json";
import actions from "@/assets/utils/utils.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import $ from "jquery";
import Vue from "vue";

localize({
  es,
});

localize("es");

export default {
  components: {
    BOverlay,
    BBadge,
    SvgIcon,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BTable,
    BPagination,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    vSelect,
    BLink,
    BCardHeader,
    BCardTitle,
    BTooltip,
    flatPickr,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      path: mdiTicket,
      login_user: "",

      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      currentPageModificado: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      fields: [
        {
          key: "persona",
          label: "Persona/Boleto",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "30%" },
        },
        {
          key: "fechaMarcacion",
          label: "Fecha marcación",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "15%" },
        },
        // {
        //   key: 'tipo_marcacion', label: 'Tipo de marcación', sortable: true, thClass: 'text-center', thStyle: { width: '10%' },
        // },
        {
          key: "tipoBoleto",
          label: "Tipo boleto",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "12%" },
        },
        {
          key: "tipoTarifa",
          label: "Tipo tarifa",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "13%" },
        },
        {
          key: "tipoPasajero",
          label: "Tipo pasajero",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "12%" },
        },
        {
          key: "observacion_marcacion",
          label: "Observación marcación",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "15%" },
        },
      ],
      items: [],

      required,
      integer,

      field_persona: "",
      field_boleto: "",

      tipo_boleto: "",
      tipo_tarifa: "",
      tipoPasajero: "",
      tipo_marcacion: "PEN",
      tipos_marcaciones: [],
      observaciones_filtro: "",
      fecha_desde: "",
      fecha_desde_marcacion: "",
      fecha_hasta: "",
      fecha_hasta_marcacion: "",
      codigo: "",

      codigo_viaje: "",
      estado_viaje: "",
      fecha_inicio: "",
      fecha_fin: "",
      trayecto: "",
      chofer: "",
      bus: "",
      capacidad_bus: "",

      marcacionCorrecta: "",
      permisos: "",
      mostrarLoader: false,

      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
        locale: Spanish,
      },
    };
  },
  mounted() {
    //   if (this.$route.params.token) {
    //     this.token = this.$route.params.token
    this.cargarTipoPasajero();
    this.getMarcacion();
    //   } else {
    // console.log('NO ENTRO')
    //   }
    $('#contenedor-botones').append($('#btn-excel')).append($('#btn-pdf'))
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  methods: {
    comprobarPermisos() {
      if (localStorage.getItem("permisos").indexOf("rep_boleto_caducado") === -1) {
        this.$router.push({ name: "not-permitted" });
      } else {
        this.permisos = localStorage.getItem("permisos");
      }
    },
    procesarTipoViaje(texto) {
      for (const estado_viaje of this.estados_viajes) {
        if (texto === estado_viaje.value) {
          return estado_viaje.text;
        }
      }
    },
    procesarTipoBoleto(texto) {
      for (const pasajero of this.tipo_boleto) {
        if (texto === pasajero.value) {
          return pasajero.text;
        }
      }
    },
    procesarTipoTarifa(texto) {
      for (const persona of this.tipo_tarifa) {
        if (texto === persona.value) {
          return persona.text;
        }
      }
    },
    procesarTipoPasajero(texto) {
      for (const persona of this.tipoPasajero) {
        if (texto === persona.value) {
          return persona.text;
        }
      }
    },
    validarBoleto(token_marcacion) {
      this.$swal({
        title: "Validación de Boleto Caducado",
        text: "¿Desea aceptar o rechazar este boleto?",
        icon: "warning",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Aceptar",
        denyButtonText: "Rechazar",

        customClass: {
          confirmButton: "btn btn-primary",
          denyButton: "btn btn-danger ml-1",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        this.marcacionCorrecta = result.value;
        if (result.value === true) {
          this.$swal({
            icon: "success",
            title: "Validación boleto caducado",
            text: "El boleto ha sido aceptado con éxito.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (result.value === false) {
          this.$swal({
            icon: "success",
            title: "Validación boleto caducado",
            text: "El boleto ha sido rechazado con éxito.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
        if (
          this.marcacionCorrecta === false ||
          this.marcacionCorrecta === true
        ) {
          axios
            .post("api", {
              query: `mutation validacionCaducidadBoleto($tokenMarcacion: String!, $marcacionCorrecta: Boolean!){
                  validacionCaducidadBoleto(tokenMarcacion:$tokenMarcacion, marcacionCorrecta: $marcacionCorrecta)
                  {
                      status,
                      message,
                  }
              }`,
              variables: {
                tokenMarcacion: token_marcacion,
                marcacionCorrecta: this.marcacionCorrecta,
              },
            })
            .then((response) => {
              if (response.status === 200) {
                if (
                  response.data.data.validacionCaducidadBoleto.status ===
                  "success"
                ) {
                  this.getMarcacion();
                }
              }
            });
        }
      });
    },
    cargarTipoPasajero() {
      axios
        .post("api", {
          query: `{
                      getTipoPasajero{
                          lista{
                              text,
                              value,
                          },
                          status,
                          message
                      }
                      getTiposMarcaciones{
                          lista{
                              text,
                              value,
                          },
                          status,
                          message
                      }
                  }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getTipoPasajero.status === "success") {
              this.tipoPasajero = response.data.data.getTipoPasajero.lista;
              this.tipos_marcaciones =
                response.data.data.getTiposMarcaciones.lista;
            }
          }
        });
    },
    prueba(value) {
      const pagina_actual = value;
      // this.currentPage = pagina_actual
      const limite_superior = value * this.perPage;
      const limite_inferior = (value - 1) * this.perPage;
      const desde = limite_inferior;
      const hasta = limite_superior;

      this.getMarcacion('', '', desde, hasta, pagina_actual);
    },
    filtrar() {
      this.getMarcacion();
    },
    getMarcacion(excel_btn = '', pdf_btn = '', desde = 0, hasta = 15, pagina_actual = 1) {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query getMarcaciones($codigo: String!, $observacion: String!, $fechaMarcacionDesde: String!, $fechaMarcacionHasta: String!, $fechaValidacionDesde: String!, $fechaValidacionHasta: String!, $tipoMarcacion: String!, $excel: String!, $pdf: String!, $desde: Int!, $hasta: Int!){
                      getMarcaciones(codigo: $codigo, observacion: $observacion, fechaMarcacionDesde: $fechaMarcacionDesde, fechaMarcacionHasta: $fechaMarcacionHasta, fechaValidacionDesde: $fechaValidacionDesde, fechaValidacionHasta: $fechaValidacionHasta, tipoMarcacion: $tipoMarcacion, excel:$excel, pdf:$pdf, desde: $desde, hasta: $hasta){
                          marcaciones{
                              viaje{
                                codigo
                                chofer{
                                  username
                                  first_name: firstName
                                  last_name: lastName
                                }
                              }
                              token,
                              fechaCreacion,
                              fechaMarcacion,
                              persona{
                                  token,
                                  cedula,
                                  ruc,
                                  nombres,
                                  apellidos,
                                  tipoNatJur,
                                  tipoPasajero,
                                  nombreComercial,
                                  razonSocial,
                                  email,
                                  esExtranjero,
                              },
                              boleto{
                                  token,
                                  codigoQr,
                                  numero_documento: numeroDocumento,
                                  producto_contifico: productoContifico,
                                  boletoshort,
                                  secuencia,
                                  fechaCaducidad,
                                  tipoBoleto,
                                  tipoTarifa
                              },
                              observacion_marcacion: observacionMarcacion,
                              caducado_pendiente_revisar: caducadoPendienteRevisar,
                              caducado_validado: caducadoValidado,
                              marcacion_correcta: marcacionCorrecta,
                              validacionCaducidad{
                                  fecha_hora_validacion: fechaHoraValidacion,
                                  usuario{
                                      username,
                                  },
                              }
                          },
                          listaTipoBoleto{
                              value,
                              text,
                          },
                          listaTipoTarifa{
                              value,
                              text,
                          },
                          total,
                          status,
                          message,
                          dataarchivo
                      }
                  }`,
          variables: {
            token: this.$route.params.token,
            codigo: this.codigo,
            observacion: this.observaciones_filtro,
            fechaMarcacionDesde: this.fecha_desde_marcacion,
            fechaMarcacionHasta: this.fecha_hasta_marcacion,
            fechaValidacionDesde: this.fecha_desde,
            fechaValidacionHasta: this.fecha_hasta,
            tipoMarcacion: this.tipo_marcacion,
            excel: excel_btn,
            pdf: pdf_btn,
            desde: desde,
            hasta: hasta,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getMarcaciones.status === "success") {
                if(response.data.data.getMarcaciones.marcaciones){
                    this.items = response.data.data.getMarcaciones.marcaciones;
                    this.totalRows = response.data.data.getMarcaciones.total;
                    this.currentPage = 1;
                    this.currentPageModificado = pagina_actual;
                    this.tipo_boleto = response.data.data.getMarcaciones.listaTipoBoleto;
                    this.tipo_tarifa = response.data.data.getMarcaciones.listaTipoTarifa;
                    //   this.codigo_viaje = response.data.data.getMarcaciones.viaje.codigo
                    //   this.estado_viaje = response.data.data.getMarcaciones.viaje.estado
                    //   if (isNaN(response.data.data.getMarcaciones.viaje.fecha_inicio) === true) {
                    //     this.fecha_inicio = new Date(response.data.data.getMarcaciones.viaje.fecha_inicio).toLocaleString('pt-BR')
                    //   } else {
                    //     this.fecha_inicio = 'N/A'
                    //   }
                    //   if (isNaN(response.data.data.getMarcaciones.viaje.fecha_fin) === true) {
                    //     this.fecha_fin = new Date(response.data.data.getMarcaciones.viaje.fecha_fin).toLocaleString('pt-BR')
                    //   } else {
                    //     this.fecha_fin = 'N/A'
                    //   }
                    //   this.trayecto = `${response.data.data.getMarcaciones.viaje.trayecto.origen.nombre} - ${response.data.data.getMarcaciones.viaje.trayecto.destino.nombre}`
                    //   this.chofer = response.data.data.getMarcaciones.viaje.chofer.username
                    //   this.bus = `${response.data.data.getMarcaciones.viaje.bus.placa} / ${response.data.data.getMarcaciones.viaje.bus.disco}`
                    //   this.capacidad_bus = response.data.data.getMarcaciones.viaje.num_pasajeros_marcado
                }
                else{
                    const data = response.data.data.getMarcaciones.dataarchivo
                    if (excel_btn === '1') {
                        actions.cargarArchivos(data, 'Marcaciones.xlsx', 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64')
                    } else {
                        actions.cargarArchivos(data, 'Marcaciones.pdf', 'data:application/pdf;base64')
                    }
                }
                this.mostrarLoader = false;
            } else {
              this.$router.push({ name: "error-404" });
            }
          }
        });
    },
    abrirDetalleMarcacion(item, index, event) {
      if (item.persona) {
        this.field_persona = item.persona;
        this.showModal("modal-persona");
      } else {
        this.field_boleto = item.boleto;
        this.showModal("modal-boleto");
      }
    },
    showModal(name) {
      this.$refs[name].show();
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
</style>
